import api from './api';
import { PostoCombustivel, ApiResponse } from '../types';

export const postoService = {
  listar: async (): Promise<PostoCombustivel[]> => {
    const response = await api.get<PostoCombustivel[]>('/postos');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<PostoCombustivel> => {
    const response = await api.get<PostoCombustivel>(`/postos/${id}`);
    return response.data;
  },

  cadastrar: async (posto: PostoCombustivel): Promise<ApiResponse<PostoCombustivel>> => {
    const response = await api.post<ApiResponse<PostoCombustivel>>('/postos', posto);
    return response.data;
  },

  atualizar: async (id: number, posto: PostoCombustivel): Promise<ApiResponse<PostoCombustivel>> => {
    const response = await api.put<ApiResponse<PostoCombustivel>>(`/postos/${id}`, posto);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/postos/${id}`);
    return response.data;
  },

  listarAtivos: async (): Promise<PostoCombustivel[]> => {
    const response = await api.get<PostoCombustivel[]>('/postos/ativos');
    return response.data;
  },
};
